// THE MAIN URL FOR THE API

const hostName = window.location.hostname;
const localHost = hostName === "localhost" ? "127.0.0.1" : hostName;
const online =
  hostName.toLowerCase() === 'snapcap-front-dev.8byteslab.com' ||
    hostName.toLowerCase() === 'dashboard.snap-drive.net' ||
hostName.toLowerCase() === 'dashboard-stg.snap-drive.net';
const scheme = window.location.protocol;
const envMainHost = process.env.VUE_APP_MAIN_HOST;
const envSocketHost = process.env.VUE_APP_SOCKET_HOST;
let MAIN_HOST, SOCKET_HOST, PRODUCTION_WARNING;

if (!online) {
  MAIN_HOST = `http://${localHost}:8000`;
  SOCKET_HOST = `http://${localHost}:3000/`;
} else if (hostName.toLowerCase() === "snapcap-front-dev.8byteslab.com") {
  MAIN_HOST = `https://snapcap-back-dev.8byteslab.com`;
  SOCKET_HOST = `https://snapcap-node-dev.8byteslab.com/`;
} else if (hostName.toLowerCase() === 'dashboard-stg.snap-drive.net') {
  MAIN_HOST = `https://api-stg.snap-drive.net`;
  SOCKET_HOST = `https://node-stg.snap-drive.net/`;
} else if (hostName.toLowerCase() === 'dashboard.snap-drive.net') {
  MAIN_HOST = `https://api.snap-drive.net`;
  SOCKET_HOST = `https://node.snap-drive.net/`;
}else{
  MAIN_HOST = `https://api-stg.snap-drive.net`;
  SOCKET_HOST = `https://node-stg.snap-drive.net/`;
}

if (envMainHost) {
  MAIN_HOST = envMainHost;
}
if (envSocketHost) {
  SOCKET_HOST = envSocketHost;
}


import avatar from "@/assets/avatar.jpg";
import company from "@/assets/company.png";

export const IMAGES_MAIN_URL = MAIN_HOST;

export default {
  MAIN_URL: MAIN_HOST,
  IMAGES_URL: IMAGES_MAIN_URL,
  PRODUCTION_WARNING: PRODUCTION_WARNING || false,
  GET_IMAGE(url) {
    if (url == "0" || url == null) return avatar;
    return IMAGES_MAIN_URL + "/" + (url[0] === "/" ? url.substr(1) : url);
  },
  GET_COMPANY_IMAGE(url) {
    if (url == "0" || url == null) return company;
    return IMAGES_MAIN_URL + "/" + (url[0] === "/" ? url.substr(1) : url);
  },
  GET_TERM(url) {
    if (url == "0" || url == null) return avatar;
    return IMAGES_MAIN_URL + "/storage/" + url;
  },
  ACTIONS: {
    STORAGE_LINK: "storage",
    TERMS_STORAGE_LINK: "files",
    GLOBAL_MESSAGE: "global_message",
    TERMS: "terms_captain",
    RESERVATION_QUEUE: "reservation_queue",
    BROADCAST_PRESETS: "broadcast-preset",
    BROADCAST: "broadcast",
    SUGGESTION_ALLOWED_CAPTAIN: "suggestion_allowed_captain",
    CAPTAIN_STATISTICS: "statistics/captain/all_performance",
    CAPTAIN_MONTHLY_BOOKINGS_COUNTS: "captain/monthly-bookings-counts",
    CAPTAIN_SHIFTS_STATS: "captain/shifts-stats",
    CAPTAIN_SHIFT_LOGS: "captain-shift",
    CAPTAIN_SHIFT_LOGS_AVG: "captain-shifts-avg",
    CAPTAIN_MONTHLY_BOOKINGS_STATS: "captain/captain_bookings_stats",
    CAPTAIN_ACCEPTANCE_RATIO: "statistics/captain/all_acceptance_ratio",
    CAPTAIN_RATINGS: (id) => `captain/${id}/ratings`,
    DISPATCH_BOOKINGS: "booking/dispatch",
    BEESLINE_STATSTICS: "beesline/statistics",
    BEESLINE_STORE: "beesline/store",
    BEESLINE_AREA_CLUSTER: "beesline/area_cluster",
    BEESLINE_CHECK_VOUCHER: "beesline/voucher/check",
    BEESLINE_USE_VOUCHER: "beesline/voucher/use",
    LOCATION_CLUSTER: "location_cluster",
    OSM: "statistics/osm",
    BOOKINGS: "booking",
    LOGIN: "login",
    SEND_CODE: "admin_send_code",
    RESET_PASSWORD_EMAIL: "forgot_password/request",
    RESET_PASSWORD: "forgot_password/reset",
    LOGOUT: "logout",
    CHECK_TOKEN: "check_auth",
    USERS: "user",
    STAFF: "staff",
    USER_META_DETAILS: "user_meta_details",
    LOCATIONS: "location",
    AREA: "area",
    PASSENGERS: "passenger",
    // Owner item 3.1: {all, active, inactive, banned, window_days}
    PASSENGER_STATE_COUNTS: "passenger/state-counts",
    CREATE_PASSENGER: "admin-passenger",
    COMPANY_REQUESTS: "company-request",
    PASSENGERS_NUMBER: "passenger_numbers",
    HOTEL: "hotel",
    RESTAURANT: "restaurant",
    ANALYTICS_SUMMARY: "analytics/summary",
    payments: "payments",
    ACCOUNTING_CAPTAIN_BALANCES: "accounting/captain-balances",
    ACCOUNTING_CAPTAIN_LEDGER: (captainId) => `accounting/captains/${captainId}/ledger`,
    ACCOUNTING_CAPTAIN_BALANCE: (captainId) => `accounting/captains/${captainId}/balance`,
    ACCOUNTING_SETTLEMENTS: "accounting/settlements",
    ACCOUNTING_CHART_OF_ACCOUNTS: "accounting/chart-of-accounts",
    ACCOUNTING_CHART_OF_ACCOUNT: (accountId) => `accounting/chart-of-accounts/${accountId}`,
    ACCOUNTING_JOURNAL_ENTRIES: "accounting/journal-entries",
    ACCOUNTING_REVERSE_JOURNAL_ENTRY: (journalEntryId) => `accounting/journal-entries/${journalEntryId}/reverse`,
    ACCOUNTING_PERIOD_CLOSE: "accounting/period-close",
    // Period LOCKING (accountant's decisions doc 2026-09-10, answer 2) --
    // a different endpoint from period-close above. Closing a month refuses
    // every later entry dated into it and freezes that month's report
    // snapshots; the month segment is YYYY-MM, which the route constrains.
    ACCOUNTING_PERIOD_LOCKS: "accounting/period-locks",
    ACCOUNTING_PERIOD_LOCK: (month) => `accounting/period-locks/${month}`,
    // Employees and their monthly payroll components (decisions doc answer 3b).
    ACCOUNTING_EMPLOYEES: "accounting/employees",
    ACCOUNTING_EMPLOYEE: (employeeId) => `accounting/employees/${employeeId}`,
    ACCOUNTING_EMPLOYEE_DEPARTMENTS: "accounting/employee-departments",
    ACCOUNTING_PAYROLL_COMPONENTS: "accounting/payroll-components",
    ACCOUNTING_PAYROLL_COMPONENT: (componentId) => `accounting/payroll-components/${componentId}`,
    // Saves a whole month for one employee in one request; `replace` rewrites
    // the month instead of appending, so a correction cannot be summed twice.
    ACCOUNTING_PAYROLL_COMPONENTS_BULK: "accounting/payroll-components/bulk",
    ACCOUNTING_PAYROLL_COMPONENTS_SEED: "accounting/payroll-components/seed",
    ACCOUNTING_ASSETS: "accounting/assets",
    ACCOUNTING_ADJUSTMENTS: "accounting/adjustments",
    ACCOUNTING_CASH_MOVEMENTS: "accounting/cash-movements",
    ACCOUNTING_PAYROLL_BATCHES: "accounting/payroll-batches",
    ACCOUNTING_POSTING_RULES: "accounting/posting-rules",
    ACCOUNTING_POSTING_RULE: (ruleId) => `accounting/posting-rules/${ruleId}`,
    ACCOUNTING_POSTING_FAILURES: "accounting/posting-failures",
    ACCOUNTING_POSTING_FAILURE_RETRY: (failureId) => `accounting/posting-failures/${failureId}/retry`,
    ACCOUNTING_OPERATION_ENTRIES: "accounting/operation-entries",
    ACCOUNTING_DEPRECIATION_SCHEDULES: "accounting/depreciation-schedules",
    ACCOUNTING_DEPRECIATION_SCHEDULE: (scheduleId) => `accounting/depreciation-schedules/${scheduleId}`,
    ACCOUNTING_DEPRECIATION_RUNS: "accounting/depreciation-runs",
    ACCOUNTING_TRIAL_BALANCE: "accounting/reports/trial-balance",
    ACCOUNTING_BALANCE_SHEET: "accounting/reports/balance-sheet",
    ACCOUNTING_INCOME_STATEMENT: "accounting/reports/income-statement",
    ACCOUNTING_CAPTAIN_STATEMENT: (captainId) => `accounting/reports/captains/${captainId}/statement`,
    ACCOUNTING_MONTHLY_SETTLEMENTS: "accounting/reports/monthly-settlements",
    // Accountant's document 2026-10-03, section 2: the seven ledger reports.
    ACCOUNTING_GENERAL_JOURNAL_SUMMARY: "accounting/reports/general-journal-summary",
    ACCOUNTING_GENERAL_JOURNAL_SUMMARY_ENTRIES: "accounting/reports/general-journal-summary/entries",
    ACCOUNTING_DRIVER_STATEMENT: "accounting/reports/driver-statement",
    ACCOUNTING_CASH_FLOW_STATEMENT: "accounting/reports/cash-flow-statement",
    ACCOUNTING_EQUITY_CHANGES: "accounting/reports/equity-changes",
    ACCOUNTING_ACCOUNT_STATEMENT: "accounting/reports/account-statement",
    ACCOUNTING_ACCOUNTING_BALANCE: "accounting/reports/accounting-balance",
    ACCOUNTING_ACCOUNTS_INVENTORY: "accounting/reports/accounts-inventory",
    // Vehicle maintenance register (decisions doc answer 3a). The two
    // "-options" / "-cars" paths are separate endpoints, not sub-resources:
    // the backend declares them before the {car_maintenance} binding.
    CAR_MAINTENANCE: "car-maintenance",
    CAR_MAINTENANCE_RECORD: (recordId) => `car-maintenance/${recordId}`,
    CAR_MAINTENANCE_POST: (recordId) => `car-maintenance/${recordId}/post`,
    CAR_MAINTENANCE_OPTIONS: "car-maintenance-options",
    CAR_MAINTENANCE_CARS: "car-maintenance-cars",
    // Fleet-wide car picker (plate / brand / driver name or phone) — the
    // platform's only car-listing endpoint, shared with the cameras page.
    CARS: "cars",
    // Unified report engine (requirements doc 2026-09-09): one catalog
    // endpoint plus one endpoint that serves every report by slug.
    REPORTS: "reports",
    REPORT: (slug) => `reports/${slug}`,
    SEASONAL_RESERVATIONS: "seasonal_reservation",
    SMS_CODES: "sms-codes",
    SERVICES: "service",
    // Safe Ride (رحلة آمنة) in-car cameras
    CAMERAS: "camera",
    CAMERA_LIVE_URL: (id) => `camera/${id}/live-url`,
    CAMERA_STREAM_LOGS: "camera-stream-logs",
    PAYMENT_METHODS: "payment-method",
    BONUS: "bonus",
    BONUS_PACKAGE: "bonus_package",
    BONUS_PACKAGE_BONUSES: (id) => `bonus_package/${id}/bonuses`,
    REGISTRATION_REQUESTS: "registration_request",
    SERVICE_PRICES: (id) => `price?service_id=` + id,
    SERVICE_CARS: (id) => `service/${id}/cars`,
    UPDATE_CAR_DATA: (id) => `car/${id}`,
    SERVICE_LOCATIONS: (id) => `service/${id}/locations`,
    RIDE: "ride",
    JOIN_RIDE: (ride_id) => `ride/${ride_id}/join`,
    ROLES: "roles",
    PERMISSIONS: "permissions",
    CAPTAINS: "captain",
    // Owner item 3.1: {all, active, inactive, banned, window_days}
    CAPTAIN_STATE_COUNTS: "captain/state-counts",
    CAPTAIN_CAR: "car",
    QR_CODE: "get_qr_code",
    CAPTAIN_CARS: (captain_id) => `captain/${captain_id}/cars`,
    // Owner item 2.1: the restricted welcome balance. GET answers
    // {summary, movements}; the three POSTs answer {status, summary}.
    CAPTAIN_WELCOME_BONUS: (captain_id) => `captain/${captain_id}/welcome-bonus`,
    // Accountant doc 2026-10-03 item 1.5: the booking's automatic
    // cancellation compensation (read: BOOKINGS; grant: MANAGE_FINANCE_ADJUSTMENTS).
    BOOKING_CANCELLATION_COMPENSATION: (booking_id) => `booking/${booking_id}/cancellation-compensation`,
    BOOKING_CANCELLATION_COMPENSATION_GRANT: (booking_id) => `booking/${booking_id}/cancellation-compensation/grant`,
    BOOKING_CANCELLATION_COMPENSATION_PROCESS: (booking_id) => `booking/${booking_id}/cancellation-compensation/process`,
    CAPTAIN_WELCOME_BONUS_CLOSE: (captain_id) => `captain/${captain_id}/welcome-bonus/close`,
    CAPTAIN_WELCOME_BONUS_CLOSE_APPROVE: (captain_id) => `captain/${captain_id}/welcome-bonus/close/approve`,
    CAPTAIN_WELCOME_BONUS_CLOSE_CANCEL: (captain_id) => `captain/${captain_id}/welcome-bonus/close/cancel`,
    CAR_BRANDS: "car-brand",
    VEHICLE_TYPE: "vehicle_type",
    CAR_BRAND_MODELS: (id) => `car-brand/${id}/models?perPage=100`,
    COLORS: "color",
    BANKS: "bank",
    NOTES: "note",
    NATIONALITIES: "nationality",
    PHONE_VOUCHERS: "phone_voucher",
    VOUCHERS: "voucher",
    FIRST_RIDE_PAX: "customer_care/first_ride_pax",
    ANAS: "customer_care/anas_stats",
    DEMAND_PUMP: "voucher/demand_pump",
    LOGS: "log",
    RANDOM_VOUCHER: "voucher/random",
    CHECK_LOGS: "check_log",
    TIMELINE: "timeline",
    REDISPATCH_BOOKING: (bookingId) => `booking/${bookingId}/redispatch`,
    // Unpaid ride (operational entries doc 2026-10-03): settle a DONE booking
    // nobody collected -- Dr 12206 receivable, shares credited.
    SETTLE_UNPAID_BOOKING: (bookingId) => `bookings/${bookingId}/settle-unpaid`,
    AVAILABLE_INTERVIEW_TIMES: "available_interview_time",
    INTERVIEW_SLICE: "available_interview_time/slice",
    INTERVIEW_MAX_CAPTAINS: `available_interview_time/max_captains`,
    INTERVIEW_STATUS: "interview_status",
    INTERVIEWS: "interview",
    CAPTAIN_SCHEDULE: (captainId) => `captain/${captainId}/schedule`,
    PENALTY: "penalty",
    // START SETTINGS
    SETTINGS: "setting",
    SETTINGS_UPDATE: "setting/update",
    USER_CANCELLATION_REASONS: "cancellation-reason",
    CANCELLATION_REASONS: "cancellation-reason",
    CHANGE_SEASON: "setting/season",
    // END SETTINGS
    CAPTAIN_TRANSACTIONS: (captainId) => `captain/${captainId}/transactions`,
    PASSENGER_TRANSACTIONS: (passengerId) =>
      `passenger/${passengerId}/transactions`,
    LOCATION_CONTAINERS: "location_container",
    BONUSES_REQUEST: "bonus_request",
    STATISTICS: "statistic",
    STATIONS: "landmark",
    ADDRESS: "address",
    LANDMARKS: "landmark",
    PASSENGER_RATING_CAUSES: "passenger_rating_cause",
    CAPTAIN_RATING_CAUSES: "captain_rating_cause",
    PASSENGER_ID_CONVERTER: "passenger_id_converter",
    TICKETS: "ticket",
    TICKET_ASSIGN: (ticket_id) => "ticket/" + ticket_id + "/assign",
    USER_STATS: (user_id) => `user/${user_id}/stats`,
    USER_ALL_STATS: "user/stats",
    CAPTAIN_BLACKLIST_HISTORY: (id) => `captain/${id}/blacklist_log`,
    SERVICE_EXTRA_CHARGES: (service_price_id) =>
      `service_price/${service_price_id}/extra_charge`,
    CANCELLATION_TICKETS: "ticket/cancellation",
    BLACKLIST_LOCATIONS: "blacklist_location",
    LOST_CAPTAINS: "lost_captain",
    CAPTAIN_TIMELINE: (id) => `captain/${id}/timeline`,
    CAPTAINS_STATUSES_TIMELINE: "captains-timeline",
    PRESENT_CAPTAINS: `captain/weekly_present`,
    CAPTAIN_RATINGS: (id) => `captain/${id}/ratings`,
    CAPTAIN_RATING_STATS: (id) => `captain/${id}/rating_stats`,
    ALL_END_RIDES: "timeline/end_rides",
    GHOST_RIDES: "ghost_ride",
    USER_SCHEDULE: "user_schedule",
    SUGGEST_SERVICE_CHANGE: (booking_id) =>
      `booking/${booking_id}/suggest_service_change`,
    MONEY_TRANSFER: "money_transfer",
    USER_META: (user) => `user/${user}/meta`,
    GET_LOGIN_IDENTFIER: `user/identifier`,
    CAPTAIN_CANCELLATION_REASONS: "captain_cancellation_reason",
    INCOMPLETE_CAPTAIN: "incomplete_captain",
    LEAVES: "user/leave",
    UNRESOLVED_LEAVES: "unresolved_leaves",
    APPROVE_OR_REJECT_LEAVES: "leave/approve_or_reject",
    EXTRA_HOURS: "user/extra_hours",
    UNRESOLVED_EXTRA_HOURS: "unresolved_extra_hours",
    APPROVE_OR_REJECT_EXTRA_HOURS: "extra_hours/approve_or_reject",
    EMPLOYMENT_TYPE: "employment_type",
    SALARY_EVENTS: "salary_event",
    EMPLOYMENT_TYPE_DELAY_POLICY: (id) =>
      `employment_type/${id}/delay_policies`,
    EMPLOYMENT_TYPE_GENERAL_HOLIDAY: (id) =>
      `employment_type/${id}/general_holidays`,
    SALARY_REPORT: "salary_report",
    ALL_SALARY_REPORT: "/salaries_reports",
    REGENERATE_REPORT: "/salary_report/generate",
    REGENERATE_ALL_REPORTS: "salaries_reports/generate",
    USER_PROJECT_SCHEDULES: "user_project_schedule",
    PROJECT: "project",
    CREATE_HOTEL: "hotels/store",
    CREATE_COMPANY: "companies/store",
    CREATE_RESTAURANT: "restaurants/store",
    LANGUAGES: "language",
    GET_ALL_CAPTAINS: "getAllCaptains",
    GET_ALL_STATIONS: "getStations",
    GET_STATION: (id) => `stats/driver/station/${id}`,
    ALL_STATIONS: "stations",
    ADVANCED_SEARCH: "booking/search",
    EVENTS: "event",
    EVENTS_DETAILS: (id) => `event/${id}/details`,
    EVENTS_DETAILS_CAPTAINS: (id) => `event_details/${id}/captains`,
    TWILIO_TOKEN: "generate_chat_token",
    BOOKING_LOG: (id) => `booking-logs/${id}`,
    CAPTAIN_PAYMENTS: (id) => `captain/${id}/accounting`,
    SURVEYS: 'survey',
    CONSTRAINTS: 'dynamic_constraints',
    PRICE_RULES: 'priceRule',
    CAPTAIN_CHANGE_NAME_LOG: (id) => `captain/${id}/change_name_log`,
    PASSENGERS_MARKETING_PREVIEW: 'passenger/marketing/preview',
    PASSENGERS_MARKETING_SEND: 'passenger/marketing/send',
    // QA V4 #26 (v2): saved audience presets + campaign audit history.
    // Endpoints are consumed defensively (a missing backend route degrades to
    // an empty list) until the backend marketing endpoints ship.
    PASSENGERS_MARKETING_PRESETS: 'passenger/marketing/presets',
    PASSENGERS_MARKETING_PRESET: (id) => `passenger/marketing/presets/${id}`,
    PASSENGERS_MARKETING_CAMPAIGNS: 'passenger/marketing/campaigns',
    // Marketing redesign (doc 2026-08-18): specific-user search + the live
    // recipients list behind the dynamic count.
    PASSENGERS_MARKETING_SEARCH_USERS: 'passenger/marketing/search-users',
    PASSENGERS_MARKETING_RECIPIENTS: 'passenger/marketing/recipients',
    // User-submitted complaints (permission COMPLAINTS) - distinct from the
    // admin-internal booking-complaints resource above.
    COMPLAINTS: "complaints",
    COMPLAINT: (id) => `complaints/${id}`,
    COMPLAINT_STATUS: (id) => `complaints/${id}/status`,
    COMPLAINT_ACTION: (id) => `complaints/${id}/action`,
    COMPLAINT_ATTACHMENT: (id, att) => `complaints/${id}/attachments/${att}`,
  },
  SOCKET: {
    CAPTAINS: SOCKET_HOST + "captains",
    USERS: SOCKET_HOST + "users",
    GUESTS: SOCKET_HOST + "guests",
    EVENTS: {
      CAPTAIN_UPDATED_LOCATION: "captain_location_updated",
      BOOKINGS_WERE_APPROVED: "approved_bookings",
      NEW_PENDING_BOOKING: "Timeline:new_booking",
      NEW_NOW_BOOKING: "Ai:new_now_booking",
      NEW_NOTIFICATION: "Dashboard:new_notification",
      DELETE_BOOKING: "Timeline:remove_booking",
      UPDATE_BOOKING: "Timeline:update_booking",
      NEW_ACTION: "Ride:new_action",
      LATE_BOOKING: "Dashboard:late_booking",
      LATE_CAPTAIN: "Dashboard:late_captain",
      ESTIMATED_START_LATENESS: "Dashboard:estimated_start_lateness",
      ESTIMATED_END_LATENESS: "Dashboard:estimated_end_lateness",
      UPDATE_BOOKING_STATUS: "Timeline:update_booking_status",
      UPDATE_END_RIDE: "Timeline:update_end_ride",
      NEW_TICKET: "Dashboard:new_ticket",
      DISMISS_TICKET: "Dashboard:dismiss_ticket",
      RENEW_BESOIN: "Dashboard:renew_besoin",
      EXPIRED_BESOIN: "Dashboard:expired_besoin",
    },
  },
  mapBox: {
    accessToken:
      "pk.eyJ1IjoibWFqZHNhbGxvdW0iLCJhIjoiY2pzYWlqdGQ2MDJheDN5bG50aWl1bW1wMCJ9.6vf9T_7a6HgGvdH33BtrwA",
    style: "mapbox://styles/majdsalloum/cjsailsar04mb1frz6xe8w6mj",
    center: [36.2765, 33.5138],
    zoom: 12,
  },
  CONSTANTS: {
    STATES: [
      "Latakia",
      "Idlib",
      "Aleppo",
      "Raqqa",
      "Al-Hasakah",
      "Tartus",
      "Hama",
      "Deir ez-Zor",
      "Homs",
      "Damascus",
      "Rif Dimashq",
      "Quneitra",
      "Daraa",
      "Al-Suwayda",
    ],
    WHATSAPP_NUMBERS: [
      "963965656008",
      "963954044416",
      "963965656005",
      "963966080574",
    ],
    ACCOUNT_ENTRY_TYPES: [
      "wallet_migration",
      "ride",
      "payment",
      "passenger_penalty",
      "captain_penalty",
      "closing_payment",
      "payment_approval",
      "passenger_bonus",
      "captain_bonus",
    ],
    GENDER: {
      MALE: 0,
      FEMALE: 1,
    },
    COLOR_INDICATORS: {
      PENDING: "#9f43cf",
      CONFIRMED: "#8e8e88",
      STARTED: "#428bca",
      ARRIVED: "#ffa60c",
      PICKED_UP: "#e04b4a",
      DONE: "#69b869",
      STOP: "#b3e6cc",
    },
  },
};
